module.exports = __webpack_public_path__ + "img/card-default.3c5db0d.png";